<template>
	<template v-if="faqs">
		<Divider />

		<div class="faq-container">
			<h1 class="faq-container-title">{{ processedTitle }} - FAQ</h1>
			<p class="faq-container-subtitle">
				Read on for some more questions you might be asking...
			</p>
			<div class="faq-wrapper">
				<div
					v-for="(faq, index) in faqs"
					:key="index"
					class="faq-container-content"
				>
					<div class="faq-question-wrapper">
						<p
							class="faq-question"
							:class="{ 'faq-open': faq.isOpen }"
							@click="toggleAnswer(index)"
						>
							{{ faq.title }}
						</p>
					</div>
					<p
						v-if="faq.isOpen"
						class="faq-answer"
						v-html="renderAnswerWithLink(faq.answer)"
					/>
				</div>
			</div>
		</div>
	</template>

	<div v-else />
</template>

<script setup>
import { onMounted } from "vue";

const props = defineProps({
	faqs: {
		type: Array,
		required: true
	},
	processedTitle: {
		type: String,
		required: true
	}
});

const toggleAnswer = (index) => {
	const updatedFaqs = [...props.faqs];
	updatedFaqs[index].isOpen = !updatedFaqs[index].isOpen;
};

const renderAnswerWithLink = (answer) => {
	const clickableAnswer = answer.replace(
		/<a href='(.*?)'>(.*?)<\/a>/g,
		'<a href="$1" target="_blank" class="faq-question-link" style="color: #3b82f6;">$2</a>'
	);
	return clickableAnswer;
};

onMounted(() => {
	props.faqs.forEach((faq) => {
		faq.isOpen = false;
	});
});
</script>

<style lang="scss" scoped>
@import "@assets/utils.scss";

h1 {
	margin-bottom: 16px;
	color: var(--gray-800, #1d2939) !important;
	font-size: 28px !important;
	font-style: normal !important;
	font-weight: 700 !important;
	line-height: 120% !important; /* 28.8px */
	text-align: center !important;
	margin-bottom: 0 !important;
	@include breakpoint(lg) {
		margin-bottom: 24px;
	}
}

.faq-container-subtitle {
	padding-top: 12px;
	padding-bottom: 8px;
	font-size: 16px;
	color: #292b2c;
	@include breakpoint(lg) {
		padding-top: 24px;
		padding-bottom: 16px;
	}
}
.faq-container {
	width: auto;
	gap: 24px;
	background-color: white;
	border-radius: 16px;
	padding: 32px 16px;
	margin: 0 auto;
	margin-bottom: 64px;
	box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);
	@include breakpoint(lg) {
		padding: 62px;
	}
}

.faq-container-content {
	display: flex;
	flex-direction: column;
	gap: 16px;
}
.faq-question-wrapper {
	border-bottom: 1px solid #d0d5dd;
	cursor: pointer;
}
.faq-question {
	color: var(--gray-500, #060708);
	font-family: Rubik;
	font-size: 18px;
	font-style: normal;
	font-weight: 500;
	line-height: 160%; /* 29.6px */
	padding: 24px 0;
	vertical-align: middle;
}

.faq-question:not(.faq-open)::before {
	content: "+";
	color: #1e3a8a;
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
	margin-right: 10px;
}

.faq-question.faq-open::before {
	content: "-";
	color: #1e3a8a;
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
	margin-right: 10px;
}

.faq-question-link {
	color: blue !important;
}

.faq-answer {
	color: var(--gray-800, #0c141d);
	font-family: Rubik;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 150%; /* 24px */
}

a.faq-answer {
	color: red !important;
}

@media (max-width: 768px) {
	h1 {
		font-size: 26px !important;
		line-height: 110% !important;
	}

	.faq-container {
		width: auto;
		height: auto;
		padding: 20px 16px;
		margin-bottom: 16px;
	}

	.faq-question {
		font-size: 18px;
		line-height: 140%; /* 19.6px */
		padding: 12px 0;
		cursor: pointer;
	}

	.faq-answer {
		font-size: 16px;
		line-height: 140%; /* 16.8px */
	}
}

.container.px-0 {
	padding-left: 0;
	padding-right: 0;
}

:deep(.price-link) {
	color: #3b82f6;
}
</style>
